module.exports = "/lucky-balls/img/infobox/info_Box_016.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/infobox/info_Box_016.png
// module id = 1081
// module chunks = 0